import { render } from "./DocumentFieldDate.vue?vue&type=template&id=905861b8"
import script from "./DocumentFieldDate.vue?vue&type=script&lang=js"
export * from "./DocumentFieldDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__